/**
 * yt-base-pdp.js — controller for the BASE description page (v2, founder
 * 2026-08-27 redesign). This page SELLS the base; it does not sell tins:
 * one CTA (PICK THIS BASE) selects the base and opens the builder step 2
 * (?base=<slug>). Hydrates from GET /apps/yutrients/bases: tagline,
 * description, price information (90-day leads, ladder as a footnote),
 * contents chips and the leaflet-format nutrition table. No cart calls.
 */
(function () {
  'use strict';

  var BUILDER_URL = '/pages/build-your-own';

  function money(n) {
    var v = Math.round(Number(n) * 100) / 100;
    return '£' + (Number.isInteger(v) ? String(v) : v.toFixed(2));
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  async function boot() {
    var root = document.querySelector('[data-yt-base-pdp2]');
    if (!root) return;

    var handle = (window.location.pathname.match(/\/products\/([^/?#]+)/) || [])[1] || '';
    var slug = handle.replace(/^base-/, '').replace(/-90d$/, '');
    var base = null;
    try {
      var res = await fetch('/apps/yutrients/bases', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      if (res.ok) {
        var data = await res.json();
        base = (data.bases || []).find(function (b) { return b.slug === slug; }) || null;
      }
    } catch (_e) { /* handled below */ }
    if (!base) {
      // Held/unknown base — the picker is the safe home.
      window.location.replace('/pages/shop');
      return;
    }

    var set = function (sel, text) {
      var el = root.querySelector(sel);
      if (el) el.textContent = text;
    };
    set('[data-yt-base-tagline]', base.tagline || '');
    set('[data-yt-base-ingcount]', String(base.n_ingredients));
    set('[data-yt-base-desc]', base.description || base.tagline || '');
    set('[data-yt-base-why]', base.description || base.tagline || '');
    set('[data-yt-base-price90]', money(base.prices.monthly_90d));
    set('[data-yt-base-ladder]',
      money(base.prices.sub) + '/mo on the 30-day plan · ' + money(base.prices.one_time) + ' one-time');

    var chips = root.querySelector('[data-yt-base-chips]');
    if (chips) {
      chips.innerHTML = base.ingredients.map(function (ing) {
        return '<span class="yt-base-pdp2__chip"><b>' + esc(ing.name) + '</b> &middot; ' + esc(ing.dose_display) + '</span>';
      }).join('');
    }

    var nutri = root.querySelector('[data-yt-base-nutri]');
    var nutriRows = root.querySelector('[data-yt-base-nutri-rows]');
    if (nutri && nutriRows && base.ingredients.length) {
      nutriRows.innerHTML = base.ingredients.map(function (r) {
        return '<tr>' +
          '<td>' + esc(r.panel_name || r.name) + '</td>' +
          '<td class="yt-base-nutri__num">' + esc(r.dose_display || '') + '</td>' +
          '<td class="yt-base-nutri__num">' + (r.nrv_pct != null ? esc(String(r.nrv_pct)) + '%' : '&ndash;') + '</td>' +
        '</tr>';
      }).join('');
      nutri.hidden = false;
      var toggle = nutri.querySelector('.yt-base-nutri__toggle');
      toggle.addEventListener('click', function () {
        var open = nutri.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', String(open));
      });
    }

    root.querySelectorAll('[data-yt-base-pick]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (window.ytTrack) { try { ytTrack('base_pdp_pick', { base: base.slug }); } catch (_e) {} }
        window.location.assign(BUILDER_URL + '?base=' + encodeURIComponent(base.slug));
      });
    });

    document.title = base.name + ' — Yutrients';
    if (window.ytTrack) { try { ytTrack('base_pdp_viewed', { base: base.slug }); } catch (_e) {} }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
